export const DomainModelRole = Object.freeze({
  COMMAND: 'Command',
  AGGREGATE_ROOT: 'AggregateRoot',
  READ_MODEL: 'ReadModel',
  DOMAIN_EVENT: 'DomainEvent',
  GIVEN_WHEN_THEN: 'GivenWhenThen',
  TAG: 'Tag'
})

export const DomainModelRoleLabels = Object.freeze({
  [DomainModelRole.COMMAND]: 'Command',
  [DomainModelRole.AGGREGATE_ROOT]: 'Aggregate Root',
  [DomainModelRole.READ_MODEL]: 'Read Model',
  [DomainModelRole.DOMAIN_EVENT]: 'Domain Event',
  [DomainModelRole.GIVEN_WHEN_THEN]: 'Given-When-Then',
  [DomainModelRole.TAG]: 'Tag'
})
